import { render, staticRenderFns } from "./sys-common-project.vue?vue&type=template&id=af5c9fdc&scoped=true"
import script from "./sys-common-project.vue?vue&type=script&lang=js"
export * from "./sys-common-project.vue?vue&type=script&lang=js"
import style0 from "./sys-common-project.vue?vue&type=style&index=0&id=af5c9fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c9fdc",
  null
  
)

export default component.exports